<template>
  <multiselect
    v-model="localEditList"
    :placeholder="placeholder"
    label="name"
    track-by="id"
    :options="options"
    :multiple="true"
    :show-labels="false"
    :searchable="true"
    :loading="loading"
    :internal-search="false"
    :clear-on-select="false"
    :show-no-results="true"
    :hide-selected="true"
    @search-change="getAmsList"
  >
    <template slot="noOptions">
      <span>Type to search</span>
    </template>
    <template slot="noResult">
      <span>No results found</span>
    </template>
  </multiselect>
</template>

<script>
import Multiselect from "vue-multiselect"
import debounce from "lodash/debounce"

export default {
	name: "MultipleSelectAMS",
	components: { Multiselect },
	props: ["editList", "field", "placeholder"],
	data() {
		return {
			localEditList: this.editList,
			loading: false,
			options: [],
		}
	},
	watch: {
		editList(values) {
			this.localEditList = values
		},
		localEditList(values) {
			this.$root.$emit("multipleSelectAmsChange", values, this.field)
		},
	},
	methods: {
		getAmsList: debounce(function (query) {
			this.getAmsFilteredList(query)
		}, 500),
		getAmsFilteredList(query) {
			this.loading = true
			if (query) {
				this.$http
					.get(`${process.env.VUE_APP_API_URL}/ams_subjects.json`, {
						params: { q: query },
					})
					.then((res) => {
						this.options = res.data
						this.loading = false
					})
			} else {
				this.loading = false
			}
		},
	},
}
</script>
